import { FC, useEffect, useState } from "react";
import { useField } from "formik";
import { FieldGroup, IFormProps } from ".";
import { RadioInput, EnumsType } from "src/Components/Controls";
import EnumControlViewModel from "../Models/EnumControlViewModel";
import { SimpleSelect } from "@redoc/ui-kit";

interface IEnumControlProps extends IFormProps {
	model: EnumControlViewModel;

	enumValue?: string;
	enumText?: string;
};

const EnumControl: FC<IEnumControlProps> = ( { model, readOnly, setFieldValue, enumValue = "LV", enumText = "DA" } ) => {

	const [ inputProps,, helperProps ] = useField( model.FullPath );
	const [ options, setOptions ] = useState<EnumsType>([]);

    //  подтягиваем только когда model.selectedValueS2 изменился извне
    useEffect( () => {
        const normalize = (value: any) => (
            model.multiflag ? (Array.isArray(value) ? value : (value ? [value] : [])) : (value ?? null)
        );
        const normalizedModelValue = normalize(model.selectedValueS2 as any);
        const normalizedFormValue = normalize(inputProps.value);
        const valuesAreEqual = JSON.stringify(normalizedModelValue) === JSON.stringify(normalizedFormValue);
        if (!valuesAreEqual) {
            helperProps.setValue(normalizedModelValue, true);
        }
    // eslint-disable-next-line
    }, [ model.selectedValueS2, model.multiflag ] );

	useEffect( () => {
		const _opt = model.options?.map( (el: any) => ({ id: el[enumValue], title: el[enumText] }) ) ?? [];
		setOptions( _opt );
	// eslint-disable-next-line
	}, [ model.options ] );

	const onSetFieldValue = ( value: any ) => {
		setFieldValue( model.FullPath, value );
		model.setValue( value );
		model.selectedValueS2 = value;
	};

	const renderInput = () => {
		if ( model.ControlKey === "RadioGroup" ) {
			return (
				<RadioInput 
					name={ model.FullPath }
					disabled={readOnly || !model.ControlEnabling}
					items={options}
					value={ inputProps.value }
					isCol={false}
					noUnderLine
					onChangeValue={onSetFieldValue}
				/>
			);
		}
		else return (
			<div style={{ width: '100%' }}>
				<SimpleSelect
					name={ model.FullPath }
					setValue={onSetFieldValue}
					placeholder={model.nullTitle}
					className={`${model.IsValid ? '' : 'st.error'}`}
					disabled={readOnly || !model.ControlEnabling}
					options={options}
					searchEnable
					multiple={model.multiflag}
					value={ inputProps.value }
					
					isPortal={true}
				/>
			</div>
		);
	};

	return (
		<FieldGroup
			hidden={!model.ControlVisibility}
			name={model.FullPath} 
			isInvalid={!model.IsValid} 
			errorMsg={model.errorMessage}
			title={model.Caption} 
			width={model.Width ?? 12} 
			isRequired={model.IsMandatory}
			readOnly={readOnly}
		>
			{ renderInput() }
		</FieldGroup>
	);
};

export default EnumControl;
